module.exports = __webpack_public_path__ + "assets/img/banner-center2.0f8898de.jpg";